import { PageTitle } from '@components/PageTitle';
import { ETypeNote } from '@constants/typeNote';
import { type IGetNoteDetailsOutputData } from '@services/notes/dtos/getNoteDetails/OutputData';
import NoteService from '@services/notes/NoteService';
import { useQuery } from '@tanstack/react-query';
import { LoaderCircle } from 'lucide-react';
import { useParams } from 'react-router';

import Form from '../Form';

function EditNote() {
  const params = useParams();

  const { data, isPending } = useQuery<IGetNoteDetailsOutputData>({
    queryFn: async () => {
      const response = await NoteService.getDetails({
        id: params.fileId!,
      });
      return response;
    },
    queryKey: ['noteDetails', params.fileId],
    refetchOnWindowFocus: false,
  });

  return (
    <div>
      <PageTitle hasBackButton title="Editar anotação" />
      {isPending ? (
        <div className="flex min-h-52 flex-col items-center justify-center">
          <LoaderCircle className="size-8 animate-spin" />
          <p className="text-2xl">Carregando...</p>
        </div>
      ) : (
        <Form
          content={data?.content}
          presentation={data?.presentation}
          title={data?.title}
          type={data?.type as ETypeNote}
        />
      )}
    </div>
  );
}

export default EditNote;
